export default {
	accessCode: [
		"NeuroDialect#2014"
	],

	token: [
		"adiajd29348932iOFDhsif987345y97&$*#&*$&#"
	],
}